import type { User } from '@/models/types';
import type { Editor, JSONContent } from '@tiptap/react';

export const getUserMentionIds = (editor: Editor | null): User['id'][] => {
  if (!editor) {
    return [];
  }

  const json = editor?.getJSON();

  const mentionIds = new Set<string>();

  // recursively look through each node
  // if it's a `mention` node, add the id to the mentionIds array
  // if it's a `paragraph` node, recursively call getMentionIds on the content
  // if it's a `doc` node, recursively call getMentionIds on the content
  // return the mentionIds array
  const traverseNodes = (node: JSONContent) => {
    if (node.type === 'mention') {
      mentionIds.add(node.attrs?.id);
    }

    if (node.content) {
      node.content.forEach((child: JSONContent) => {
        traverseNodes(child);
      });
    }
  };

  json?.content?.forEach((node) => {
    traverseNodes(node);
  });

  return Array.from(mentionIds);
};
